export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.multiple
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: !that.multiple
  },
  {
    title: that.$l("table_label_purchaseFabricNo") || "采购单号",
    field: "purchaseFabricNo",
    headerAlign: "center",
    align: "center",
    minWidth: 130,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_fabricNo") || "物料编码",
    field: "fabricNo",
    headerAlign: "center",
    align: "center",
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_fabricName") || "物料名称",
    field: "fabricName",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_fabricContent") || "规格型号",
    field: "fabricContent",
    headerAlign: "center",
    align: "left",
    minWidth: 200,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_fabricWidth") || "有效门幅",
    field: "fabricWidth",
    headerAlign: "center",
    align: "center",
    minWidth: 120,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      const width = row.fabricWidth || "";
      const unit = row.fabricWidthUnit || "";
      return width && unit ? `${width}${unit}` : width || "--";
    },
  },
  {
    title: that.$l("table_label_fabricColor") || "颜色",
    field: "fabricColor",
    headerAlign: "center",
    align: "center",
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_series") || "系列",
    field: "series",
    headerAlign: "center",
    align: "left",
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_fabricWeight") || "克重",
    field: "fabricWeight",
    headerAlign: "center",
    align: "center",
    minWidth: 120,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      const weight = row.fabricWeight || "";
      const unit = row.fabricWeightUnit || "";
      return weight && unit ? `${weight}${unit}` : weight || "--";
    },
  },
  {
    title: that.$l("table_label_qty") || "数量",
    field: "qty",
    headerAlign: "center",
    align: "center",
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_fabricUnit") || "单位",
    field: "v_fabricUnit",
    headerAlign: "center",
    align: "center",
    minWidth: 80,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_unitPrice") || "含税单价",
    field: "unitPrice",
    headerAlign: "center",
    align: "center",
    minWidth: 120,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => {
      return cellValue != null ? Number(cellValue).toFixed(2) : "--";
    },
  },
  {
    title: that.$l("table_label_subAmount") || "价税合计",
    field: "subAmount",
    headerAlign: "center",
    align: "center",
    minWidth: 120,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => {
      return cellValue != null ? Number(cellValue).toFixed(2) : "--";
    },
  },
  {
    title: that.$l("table_label_planArrivalDate") || "计划到货日期",
    field: "planArrivalDate",
    headerAlign: "center",
    align: "center",
    minWidth: 130,
    showHeaderOverflow: true,
  },

  {
    title: that.$l("table_label_purchaseStatus") || "状态",
    field: "purchaseStatus",
    headerAlign: "center",
    align: "center",
    minWidth: 100,
    showHeaderOverflow: true,
    slots: {
      default: "status",
    },
  },
  {
    title: that.$l("table_label_originOrderNo") || "源头订单号",
    field: "originOrderNo",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_scmName") || "供方",
    field: "scmName",
    headerAlign: "center",
    align: "center",
    minWidth: 200,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_purchaserEntityName") || "需方",
    field: "purchaserEntityName",
    headerAlign: "center",
    align: "center",
    minWidth: 200,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_signPlace") || "签订地点",
    field: "signPlace",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_buyerName") || "采购人员",
    field: "buyerName",
    headerAlign: "center",
    align: "center",
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_totalAmount") || "采购金额",
    field: "totalAmount",
    headerAlign: "center",
    align: "center",
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_reviewByName") || "审核人员",
    field: "reviewByName",
    headerAlign: "center",
    align: "center",
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("table_label_reviewTime") || "审核日期",
    field: "reviewTime",
    headerAlign: "center",
    align: "center",
    minWidth: 140,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("INDEX.table_label_created_by") || "创建人",
    field: "createByName",
    headerAlign: "center",
    align: "center",
    minWidth: 200,
    showHeaderOverflow: true,
    slots: {
      default: "displayCreateByName",
    }
  },
  {
    title: that.$l("INDEX.table_label_modified_by") || "修改人",
    field: "modifyByName",
    headerAlign: "center",
    align: "center",
    minWidth: 200,
    showHeaderOverflow: true,
    slots: {
      default: "displayModifyByName",
    }
  },
]
